import { Stack, TextField } from '@mui/material';
import { Controller, type Control, type FieldErrors } from 'react-hook-form';
import { useTranslations } from '@/i18n/use-translations';

const ContributorProfileInputs = ({
  control,
  errors,
  isEditable,
}: {
  control: Control<{
    displayName: string;
    title?: string;
    organization?: string;
    bio?: string;
  }>;
  errors?: FieldErrors;
  isEditable?: boolean;
}) => {
  const t = useTranslations();

  return (
    <Stack spacing={{ xs: 1, sm: 1.5 }}>
      <Controller
        name="displayName"
        control={control}
        disabled={!isEditable}
        render={({ field }) => (
          <TextField
            fullWidth
            required
            variant="outlined"
            size="small"
            label={t('myEventsList.contributorProfileForm.displayNameInputLabel')}
            {...field}
            error={!!errors?.displayName}
            helperText={errors?.displayName?.message as string}
            sx={{
              '& .MuiOutlinedInput-root': { fontSize: { xs: '1rem', sm: '0.875rem' } },
              '& .MuiInputLabel-root': { fontSize: { xs: '0.875rem', sm: '0.875rem' } },
            }}
          />
        )}
      />
      <Controller
        name="title"
        control={control}
        disabled={!isEditable}
        render={({ field }) => (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label={t('event.detail.contributors.titleInputLabel')}
            {...field}
            error={!!errors?.title}
            helperText={errors?.title?.message as string}
            sx={{
              '& .MuiOutlinedInput-root': { fontSize: { xs: '1rem', sm: '0.875rem' } },
              '& .MuiInputLabel-root': { fontSize: { xs: '0.875rem', sm: '0.875rem' } },
            }}
          />
        )}
      />
      <Controller
        name="organization"
        control={control}
        disabled={!isEditable}
        render={({ field }) => (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label={t('myEventsList.contributorProfileForm.organizationInputLabel')}
            {...field}
            error={!!errors?.organization}
            helperText={errors?.organization?.message as string}
            sx={{
              '& .MuiOutlinedInput-root': { fontSize: { xs: '1rem', sm: '0.875rem' } },
              '& .MuiInputLabel-root': { fontSize: { xs: '0.875rem', sm: '0.875rem' } },
            }}
          />
        )}
      />
      <Controller
        name="bio"
        control={control}
        disabled={!isEditable}
        render={({ field }) => (
          <TextField
            multiline
            fullWidth
            minRows={2}
            variant="outlined"
            size="small"
            label={t('myEventsList.contributorProfileForm.bioInputLabel')}
            {...field}
            error={!!errors?.bio}
            helperText={errors?.bio?.message as string}
            sx={{
              '& .MuiOutlinedInput-root': { fontSize: { xs: '1rem', sm: '0.875rem' } },
              '& .MuiInputLabel-root': { fontSize: { xs: '0.875rem', sm: '0.875rem' } },
            }}
          />
        )}
      />
    </Stack>
  );
};

export default ContributorProfileInputs;
